"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var resetRelatedChallengeData = function resetRelatedChallengeData(params) {
  return {
    type: 'OLY_RESET_RELATED_CHALLENGE_DATA',
    payload: params
  };
};

var _default = {
  resetRelatedChallengeData: resetRelatedChallengeData
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map